import React from "react";
import { Updater } from "use-immer";

import { List } from "@mui/material";
import { useLogout } from "@src/api/user-auths/logout";
import { SubscriptionInfoAlert } from "@src/components/MainApp/Alerts/SubscriptionInfoAlert";
import { useDispatch } from "@src/store";

interface BottomNavSectionProps {
  drawerOpen: boolean;
  setAnchorEl: Updater<null | HTMLElement>;
  anchorEl: null | HTMLElement;
}
export const BottomNavSection = ({
  drawerOpen,
  setAnchorEl,
  anchorEl,
}: BottomNavSectionProps) => {
  const dispatch = useDispatch();
  const logout = useLogout();
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const helpOpen = Boolean(anchorEl);

  return (
    <List sx={{ px: drawerOpen ? 2 : 4 }}>
      {/*<IgListItemLink*/}
      {/*  hasAccess={true}*/}
      {/*  drawerOpen={drawerOpen}*/}
      {/*  Route={BottomRoutes().settings}*/}
      {/*  exact={true}*/}

      {/*<AnnouncementButton drawerOpen={drawerOpen} />*/}
      {/*<IgListItemLink*/}
      {/*  isLink={false}*/}
      {/*  drawerOpen={drawerOpen}*/}
      {/*  Route={{*/}
      {/*    path: "help",*/}
      {/*    icon: <HelpOutlineOutlined sx={{ fontSize: "16px" }} />,*/}
      {/*    sidebarName: "Help",*/}
      {/*  }}*/}
      {/*  hasAccess={true}*/}
      {/*  handleClick={handleClick}*/}
      {/*/>*/}

      {/*<Menu*/}
      {/*  style={{ justifyContent: "flex-start" }}*/}
      {/*  anchorOrigin={{ horizontal: "right", vertical: "center" }}*/}
      {/*  transformOrigin={{ horizontal: "left", vertical: "top" }}*/}
      {/*  anchorEl={anchorEl}*/}
      {/*  open={helpOpen}*/}
      {/*  onClose={handleClose}*/}
      {/*>*/}
      {/*  <MenuItem*/}
      {/*    onClick={() => {*/}
      {/*      openNewTab(knowledgeBase, "Intelligems Knowledge Base");*/}
      {/*      handleClose();*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <BookOutlined style={{ marginRight: 5 }} />*/}
      {/*    Knowledge Base*/}
      {/*  </MenuItem>*/}
      {/*  <MenuItem*/}
      {/*    onClick={() => {*/}
      {/*      contactSupport();*/}
      {/*      handleClose();*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <MailOutline style={{ marginRight: 5 }} />*/}
      {/*    Contact support*/}
      {/*  </MenuItem>*/}
      {/*  <MenuItem*/}
      {/*    onClick={() => {*/}
      {/*      dispatch(setDialog({ dialog: "onboarding", open: true }));*/}
      {/*      handleClose();*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <EmojiPeopleOutlined style={{ marginRight: 5 }} />*/}
      {/*    Open Welcome Message*/}
      {/*  </MenuItem>*/}
      {/*</Menu>*/}
      {/*<IgListItemLink*/}
      {/*  hasAccess={true}*/}
      {/*  isLink={false}*/}
      {/*  drawerOpen={drawerOpen}*/}
      {/*  handleClick={() => {*/}
      {/*    logout.mutate();*/}
      {/*  }}*/}
      {/*  Route={{*/}
      {/*    path: "",*/}
      {/*    icon: <ExitToAppOutlined sx={{ fontSize: "16px" }} />,*/}
      {/*    sidebarName: "Log Out",*/}
      {/*  }}*/}
      {/*  exact={true}*/}
      {/*/>*/}
      {drawerOpen && <SubscriptionInfoAlert />}
    </List>
  );
};
